import { MODULE_NAME } from './';
const NAME = MODULE_NAME.toUpperCase();
export const SET_SERVICES = `${NAME}/SET_SERVICES`;
export const ADD_SERVICE = `${NAME}/ADD_SERVICE`;
export const UPDATE_SERVICE = `${NAME}/UPDATE_SERVICE`;
export const REMOVE_SERVICE = `${NAME}/REMOVE_SERVICE`;
export const ADD_SSO_REQUEST = `${NAME}/ADD_SSO_REQUEST`;
